export const initCds2Counter = () => {
	const counters = document.querySelectorAll( 'section.cds2-counter' );

	if ( !counters.length )
	{
		return;
	}

	Array.from( counters ).forEach( ( it ) => {
		const counter = it.querySelector( 'div[data-start-date]' );
		const startDate = new Date( counter.dataset.startDate );
		const currentDate = new Date();
		const finishDate = new Date( counter.dataset.finishDate );
		const dateDiff = finishDate.getTime() - startDate.getTime();
		const startCount = counter.dataset.startCount;
		const finishCount = counter.dataset.finishCount || 0;
		let numbers = null;

		if ( startCount )
		{
			const hoursDiff = Math.floor( dateDiff / 1000 / 60 / 60 );
			const hoursDiffWithCurrent = ( finishDate.getTime() - currentDate.getTime() ) / 1000 / 60 / 60;
			const countLeft = Math.ceil( startCount / hoursDiff * hoursDiffWithCurrent ) > finishCount ? Math.ceil( startCount / hoursDiff * hoursDiffWithCurrent ) : finishCount;
			
			numbers = String( countLeft ).split( '' );
		}
		else
		{
			const daysDiff = Math.floor( dateDiff / 1000 / 60 / 60 / 24 );
			
			numbers = String( daysDiff ).split( '' );
		}

		while ( numbers.length < 3 )
		{
			numbers.unshift( 0 );
		}

		counter.insertAdjacentHTML( 'beforeend', `<ul>${numbers.map( ( number ) => `<li>${number}</li>` ).join( '' )}</ul>` );
	} );
};
